export default __webpack_public_path__ + "static/Montserrat-600italic-cf46ffb11f3a60d7df0567f8851a1d00.woff2";